import * as Immutable from "immutable";
import { SEVEN_DAYS_AGO, TODAY, TIME_ZONE } from "services/date-strings";
import { AnalyticsRequestParams } from "../legacyServices";

export class AnalyticsConversationsRequestParams extends AnalyticsRequestParams {
  /**
   * @returns {Immutable.Record.Class}
   * @class
   */
  static Filter = Immutable.Record({
    /** @memberof AnalyticsConversationsRequestParams.Filter# */
    startDate: SEVEN_DAYS_AGO,
    /** @memberof AnalyticsConversationsRequestParams.Filter# */
    endDate: TODAY,
    /** @memberof AnalyticsConversationsRequestParams.Filter# */
    timeZone: TIME_ZONE,
    /** @memberof AnalyticsConversationsRequestParams.Filter# */
    timeSeriesUnit: "day",
    /** @memberof AnalyticsConversationsRequestParams.Filter# */
    language: Immutable.List(),
    /** @memberof AnalyticsConversationsRequestParams.Filter# */
    platform: Immutable.List(),
    /** @memberof AnalyticsConversationsRequestParams.Filter# */
    isTestUser: undefined,
    /** @memberof AnalyticsConversationsRequestParams.Filter# */
    browser: Immutable.List(),
    /** @memberof AnalyticsConversationsRequestParams.Filter# */
    device: Immutable.List()
  });
}

const initialState = {
  requestParams: new AnalyticsConversationsRequestParams({
    filter: new AnalyticsConversationsRequestParams.Filter({
      isTestUser: false
    })
  }),
  shouldRequestPreviousPeriod: false
};

/**
 * @param {Object} state
 * @param {{properties: Object}} action
 * @returns {Object}
 */
function updateFilter(state, action) {
  const {
    /** @type AnalyticsConversationsRequestParams */
    requestParams
  } = state;

  // Create new requestParams object using `action.properties`
  const newRequestParams = new AnalyticsConversationsRequestParams({
    ...requestParams,
    filter: new AnalyticsConversationsRequestParams.Filter({
      ...requestParams.filter.toObject(),
      ...action.properties
    })
  });

  return {
    ...state,
    requestParams: newRequestParams
  };
}

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {Object}
 */
export default function analyticsConversations(state = initialState, action) {
  switch (action.type) {
    case "UPDATE_ANALYTICS_CONVERSATIONS_FILTER": {
      return updateFilter(state, action);
    }

    case "UPDATE_ANALYTICS_ANSWERS_FILTER": {
      // Update filter if Answers filter is updated
      const updatedAction = { ...action, properties: { ...action.properties } };

      if ("unit" in action.properties) {
        updatedAction.properties.timeSeriesUnit = action.properties.timeSeriesUnit;
      }

      return updateFilter(state, action);
    }

    case "UPDATE_ANALYTICS_CONVERSATIONS_SHOULD_REQUEST_PREVIOUS_PERIOD": {
      return {
        ...state,
        shouldRequestPreviousPeriod: action.value
      };
    }

    default: {
      return state;
    }
  }
}
